import {Avatar, Space, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Title} = Typography;

const TeamFotoGeneral = (datos) => {
  return (
    <Space align="center" direction="vertical" size="middle" style={{display: 'flex', textAlign: 'center', maxWidth: '300px'}}>
      <Avatar size={100} src={datos.foto} />
      <Title level={3} style={{color: appColors['ColorAz'], textAlign: 'center', height: '5vh'}}>{datos.nombre}</Title>
      <Title level={4} style={{color: 'black', textAlign: 'center'}}>{datos.carrera}</Title>
      <p style={{height: '30vh'}}>{datos.descripcion}</p>
      <p><b>Favorite experience:</b> {datos.experiencia}</p>
    </Space>
  );
};

export default TeamFotoGeneral;
